import styled from 'styled-components';

import { Input } from 'components/Input';

const Container = styled.div`
  display: flex;
  gap: 2rem;

  margin-top: 2rem;
`;

const ItemInput = styled(Input)`
  flex-basis: 50%;
`;

export { Container, ItemInput };
